import { PrivilegesQuery, usePrivilegesQuery } from '@generated'
import { MultipleItemResponse } from '@lib/kontent'
import { PrivilegeItem } from '@lib/kontent/models/PrivilegeItem'
import { getDafAndKenticoPrivileges } from '../helpers/get-daf-and-kentico-privileges'
import { getSortedPrivilegeItems } from '../helpers/get-sorted-privilege-items'

export function useLoyaltyPrivileges(privilegesContent: MultipleItemResponse<PrivilegeItem>) {
  const [{ data, fetching }] = usePrivilegesQuery()

  const availablePrivileges = getDafAndKenticoPrivileges(privilegesContent, data as PrivilegesQuery)
  const sortedPrivilegeItems = getSortedPrivilegeItems(availablePrivileges)

  return {
    availablePrivileges,
    sortedPrivilegeItems,
    fetching,
  }
}
